const TI_THRESHOLD = 1024;

/** 格式化刻度展示文案；默认单位 Gi，大于 1024 且开启 translateUnit 时展示 Ti */
function formatMarkValue(value: number, translateUnit: boolean, unit = 'Gi'): string {
  if (value > TI_THRESHOLD && translateUnit && unit === 'Gi') {
    const num = Math.floor(value / TI_THRESHOLD);
    return `${num}Ti`;
  }
  return `${value}${unit}`;
}

/** Slider 刻度，在 [min, max] 区间均匀生成 markCount 个刻度 */
export function buildSliderMarks(min: number, max: number, translateUnit = true, markCount = 5, unit = 'Gi'): Record<number, string> {
  const count = Math.max(2, Math.floor(markCount));
  const marks: Record<number, string> = {};

  if (max <= min) {
    marks[min] = formatMarkValue(min, translateUnit, unit);
    return marks;
  }

  const values = new Set<number>();
  for (let i = 0; i < count; i++) {
    const value = i === count - 1 ? max : Math.round(min + ((max - min) * i) / (count - 1));
    values.add(Math.max(min, Math.min(max, value)));
  }
  values.add(max);

  [...values]
    .sort((a, b) => a - b)
    .forEach((value) => {
      marks[value] = formatMarkValue(value, translateUnit, unit);
    });

  return marks;
}

/** 固定 5 点刻度算法（兼容历史 getMarks 分布） */
export function getMarks(min: number, max: number, translateUnit = true, unit = 'Gi'): Record<number, string> {
  const n = Math.floor(max / 4);
  const n1 = n + 1;
  const n2 = n + n1;
  const n3 = n + n2;
  const arr = [min, n1, n2, n3, max];
  const marks: Record<number, string> = {};

  arr.forEach((value) => {
    if (value > TI_THRESHOLD && translateUnit && unit === 'Gi') {
      const num = Math.floor(value / TI_THRESHOLD);
      marks[num * TI_THRESHOLD] = `${num}Ti`;
    } else {
      marks[value] = `${value}${unit}`;
    }
  });

  return marks;
}

export const DEFAULT_SLIDER_MARK_COUNT = 5;
export const LARGE_RANGE_SLIDER_MARK_COUNT = 8;
